import React from "react";
import "../../components/PetBreedList/PetBreedList.css";
import CheckIcon from "@mui/icons-material/Check";
import SearchIcon from "@mui/icons-material/Search";


const PetBreedList = ({ petBreedDetailResponse, setOpenProfile, openProfile, GetId,setOpenAddProfile}) => {

  function HandlePBChange(param) {    
    GetId(param);
  }

  return (
    <div className="container-fluid">

      <div className="petBreedList">
        <table>
          <tr className="petBreedListHeading">
            <th>ID</th>
            <th>Pet Type</th>
            <th>Pet Breed</th>
            <th>Status</th>
            <th>Details</th>
          </tr>
          {petBreedDetailResponse !== null ? (
            petBreedDetailResponse.map((petBreed) => (
              <tr key={petBreed.id}>
                <td>{petBreed.id}</td>
                <td>{petBreed.PetType}</td>
                <td>{petBreed.PetBreedType}</td>
                <td>
                  <button className="Statusbutton">
                    <CheckIcon className="icon" />
                    Active
                  </button>
                </td>
                <td>
                  <button style={{ height: "30px", width: "38px" }} onClick={() => { setOpenProfile(!openProfile); HandlePBChange(petBreed.id); setOpenAddProfile(false); }}>
                    <SearchIcon className="icon" />
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <p>empty</p>
          )}


        </table>
      </div>
    </div>
  );
};

export default PetBreedList;
